module.exports = __webpack_public_path__ + "static/media/GC_logo.0662d9de.svg";